import { API } from "@thenounproject/lingo-core";
import _pick from "lodash/pick";
import { createAsyncAction } from "../actionCreators";

type Args = {
  assetId: string;
  data: {
    name?: string;
    notes?: string;
    keywords?: string;
    meta?: Record<string, unknown>;
    colors?: unknown;
    url?: string;
  };
};

const [useSaveAssetMetadata, saveAssetMetadata] = createAsyncAction(
  {
    action: "assets/saveMetadata",
    undo: {
      message: () => "Updated asset metadata",
      captureState: ({ assetId, data }: Args, { getState }) => {
        const asset = getState().entities.assets.objects[assetId];
        return asset ? _pick(asset, Object.keys(data)) : {};
      },
      performUndo: ({ assetId }: Args, captured: unknown, { dispatch }) => {
        void dispatch(saveAssetMetadata({ assetId, data: captured as Args["data"] }));
      },
    },
  },
  async ({ assetId, data }: Args) => {
    const res = await API.call<{ asset: string }>({
      endpoint: `assets/${assetId}`,
      method: "PUT",
      data,
    });
    return { ...res, result: res.result.asset };
  }
);

export default useSaveAssetMetadata;
export { saveAssetMetadata };
